import InputBase from './CheckBox';
export * from './CheckBox';
export const CheckBox = InputBase;

export default InputBase;
